import { ForwardedRef, useCallback, useRef } from 'react'

/**
 * A ref the component reads itself that also fills the ref its parent forwarded (e.g. a form
 * library's). The component reaches its own element without looking it up by id, which other
 * content on the page (a comment, a description) could share.
 */
export const useForwardedRef = <T>(forwarded: ForwardedRef<T>) => {
  const own = useRef<T | null>(null)
  const setRef = useCallback(
    (element: T | null) => {
      own.current = element
      if (typeof forwarded === 'function') forwarded(element)
      else if (forwarded) forwarded.current = element
    },
    [forwarded]
  )
  return [own, setRef] as const
}
